import { render, staticRenderFns } from "./KucunModal.vue?vue&type=template&id=3caf8d32&"
import script from "./KucunModal.vue?vue&type=script&lang=js&"
export * from "./KucunModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports